import MUMErrors from './MUMErrors'

export default class Form {

  /**
   * Create a new MUMForm instance
   *
   * @param {object} data
   */
  constructor(data) {
    this.initialState = _.cloneDeep(data)

    for (let field in data) {
      this[field] = data[field]
    }

    this.errors = new MUMErrors()
    this.busy = false
    this.successful = false
    this.statusMessage = ''
  }

  /**
   * Reset the form fields
   *
   * @param
   */
  reset(clearErrors = true){
    for (let field in this.initialState) {
      this[field] = _.cloneDeep(this.initialState[field])
    }

    if(clearErrors) {
      this.errors.clear()
    }
  }

  /**
   * Indicate the form has started processing
   */
  startProcessing(){
    this.errors.clear()
    this.busy = true
    this.successful = false
  }

  /**
   * Indicate the form has stopped processing,
   * update the status + message
   */
  finishProcessing(statusMessage = '') {
    this.busy = false
    this.successful = true
    this.statusMessage = statusMessage
  }

  /*
  * Set the validation errors
  */
  setErrors(errors){
    this.busy = false

    this.errors.set(errors)
  }
}